/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  asset: {
    font: {
      "Audimat 3000 Regulier": {
        400: {
          normal: "Audimat3000-Regulier.var-subset",
        },
      },
      Inter: {
        "300 800": {
          normal: "Inter.var-subset",
        },
      },
    },
  },
  borderRadius: {
    regular: "0.1875rem",
    medium: "0.375rem",
    large: "1rem",
  },
  borderWidth: {
    100: 0,
    200: "0.0625rem",
    300: "0.125rem",
  },
  color: {
    bg: {
      feedback: {
        error: "rgb(255, 232, 235)",
        info: "rgb(228, 234, 255)",
        success: "rgb(199, 251, 206)",
        warning: "rgb(255, 241, 204)",
        primary: "rgb(45, 50, 57)",
      },
      interactive: {
        primary: {
          base: "rgb(66, 94, 255)",
          active: "rgb(66, 94, 255)",
          focus: "rgb(49, 68, 217)",
          hover: "rgb(49, 68, 217)",
        },
        secondary: {
          focus: "rgb(236, 239, 242)",
          hover: "rgb(236, 239, 242)",
          base: "rgb(255, 255, 255)",
          active: "rgb(255, 255, 255)",
        },
        tertiary: {
          focus: "rgb(236, 239, 242)",
          hover: "rgb(236, 239, 242)",
          base: "rgba(0, 0, 0, 0)",
          active: "rgba(0, 0, 0, 0)",
        },
        destructive: {
          base: "rgb(219, 34, 81)",
          active: "rgb(219, 34, 81)",
          focus: "rgb(182, 7, 60)",
          hover: "rgb(182, 7, 60)",
        },
        disabled: "rgb(216, 221, 227)",
        link: "rgb(228, 234, 255)",
        selected: "rgb(246, 248, 255)",
      },
      ui: {
        primary: "rgb(255, 255, 255)",
        secondary: "rgb(247, 249, 251)",
        tertiary: "rgb(236, 239, 242)",
      },
      overlay: {
        secondary: "rgb(255, 255, 255)",
        primary: "rgb(255, 255, 255)",
      },
      field: {
        base: "rgb(255, 255, 255)",
        disabled: "rgb(236, 239, 242)",
      },
      product: {
        beta: "rgb(230, 208, 255)",
        federal: "rgb(221, 255, 70)",
      },
    },
    border: {
      feedback: {
        error: "rgb(219, 34, 81)",
        info: "rgb(66, 94, 255)",
        success: "rgb(0, 131, 68)",
        warning: "rgb(255, 187, 0)",
      },
      field: {
        active: "rgb(66, 94, 255)",
        focus: "rgb(66, 94, 255)",
        base: "rgb(216, 221, 227)",
        error: "rgb(219, 34, 81)",
        disabled: "rgb(236, 239, 242)",
      },
      interactive: {
        focus: "rgb(66, 94, 255)",
        selected: "rgb(66, 94, 255)",
        primary: {
          base: "rgba(0, 0, 0, 0)",
          active: "rgba(0, 0, 0, 0)",
          focus: "rgba(0, 0, 0, 0)",
          hover: "rgba(0, 0, 0, 0)",
        },
        secondary: {
          base: "rgb(216, 221, 227)",
          active: "rgb(216, 221, 227)",
          focus: "rgb(216, 221, 227)",
          hover: "rgb(216, 221, 227)",
        },
        destructive: "rgb(219, 34, 81)",
        disabled: "rgba(0, 0, 0, 0)",
      },
      ui: {
        primary: "rgb(216, 221, 227)",
        secondary: "rgb(236, 239, 242)",
      },
    },
    fill: {
      feedback: {
        warning: "rgb(255, 187, 0)",
        error: "rgb(219, 34, 81)",
        info: "rgb(66, 94, 255)",
        success: "rgb(0, 131, 68)",
      },
      ui: {
        primary: "rgb(63, 69, 76)",
        secondary: "rgb(108, 114, 122)",
      },
      field: {
        base: "rgb(84, 90, 98)",
      },
      interactive: {
        primary: "rgb(255, 255, 255)",
        destructive: "rgb(219, 34, 81)",
      },
    },
    shadow: {
      interactive: {
        focus: "rgb(49, 68, 217)",
        primary: "rgb(255, 255, 255)",
      },
      ui: {
        primary: "rgba(7, 8, 12, 0.1)",
        secondary: "rgba(7, 8, 12, 0.05)",
      },
    },
    text: {
      feedback: {
        error: "rgb(182, 7, 60)",
        success: "rgb(0, 105, 51)",
        info: "rgb(49, 68, 217)",
        warning: "rgb(102, 75, 0)",
        base: "rgb(35, 37, 42)",
      },
      interactive: {
        base: "rgb(49, 68, 217)",
        active: "rgb(106, 0, 169)",
        secondary: "rgb(84, 90, 98)",
        disabled: "rgb(108, 114, 122)",
        selected: "rgb(49, 68, 217)",
        primary: {
          base: "rgb(255, 255, 255)",
          active: "rgb(255, 255, 255)",
          focus: "rgb(255, 255, 255)",
          hover: "rgb(255, 255, 255)",
        },
        destructive: "rgb(182, 7, 60)",
      },
      ui: {
        primary: {
          base: "rgb(35, 37, 42)",
          inverted: "rgb(255, 255, 255)",
        },
        secondary: "rgb(84, 90, 98)",
      },
      field: {
        placeholder: "rgb(108, 114, 122)",
        disabled: "rgb(108, 114, 122)",
      },
      product: {
        beta: "rgb(135, 23, 205)",
        federal: "rgb(24, 26, 31)",
      },
      code: {
        function: "rgb(106, 51, 144)",
        tag: "rgb(213, 123, 16)",
        string: "rgb(35, 140, 163)",
        base: "rgb(84, 90, 98)",
        keyword: "rgb(255, 53, 162)",
        title: "rgb(255, 157, 41)",
        number: "rgb(42, 59, 166)",
        comment: "rgb(137, 142, 148)",
      },
    },
    data: {
      info: "rgb(137, 96, 194)",
      comparison: "rgb(169, 175, 180)",
      neutral: "rgb(148, 153, 159)",
      positive: "rgb(0, 131, 68)",
      negative: "rgb(219, 34, 81)",
      series: {
        1: "rgb(52, 182, 208)",
        2: "rgb(254, 190, 112)",
        3: "rgb(137, 96, 194)",
        4: "rgb(0, 131, 68)",
      },
    },
    gray: {
      0: "rgb(247, 249, 251)",
      50: "rgb(236, 239, 242)",
      100: "rgb(216, 221, 227)",
      200: "rgb(198, 203, 209)",
      300: "rgb(169, 175, 180)",
      400: "rgb(137, 142, 148)",
      500: "rgb(108, 114, 122)",
      600: "rgb(84, 90, 98)",
      700: "rgb(63, 69, 76)",
      800: "rgb(45, 50, 57)",
      900: "rgb(35, 37, 42)",
      950: "rgb(24, 26, 31)",
    },
    blue: {
      0: "rgb(246, 248, 255)",
      50: "rgb(228, 234, 255)",
      100: "rgb(207, 217, 255)",
      200: "rgb(175, 191, 255)",
      300: "rgb(138, 158, 255)",
      400: "rgb(112, 132, 255)",
      500: "rgb(66, 94, 255)",
      600: "rgb(49, 68, 217)",
      700: "rgb(37, 54, 166)",
      800: "rgb(25, 38, 125)",
      900: "rgb(18, 29, 97)",
      950: "rgb(11, 20, 77)",
    },
    purple: {
      0: "rgb(251, 246, 255)",
      50: "rgb(244, 233, 255)",
      100: "rgb(230, 208, 255)",
      200: "rgb(220, 185, 255)",
      300: "rgb(203, 145, 255)",
      400: "rgb(189, 97, 255)",
      500: "rgb(166, 54, 236)",
      600: "rgb(135, 23, 205)",
      700: "rgb(106, 0, 169)",
      800: "rgb(78, 0, 126)",
      900: "rgb(60, 2, 98)",
      950: "rgb(46, 0, 77)",
    },
    green: {
      0: "rgb(229, 255, 232)",
      50: "rgb(199, 251, 206)",
      100: "rgb(163, 242, 180)",
      200: "rgb(108, 224, 144)",
      300: "rgb(30, 203, 106)",
      400: "rgb(0, 164, 85)",
      500: "rgb(0, 131, 68)",
      600: "rgb(0, 105, 51)",
      700: "rgb(0, 80, 37)",
      800: "rgb(0, 59, 27)",
      900: "rgb(9, 44, 23)",
      950: "rgb(0, 33, 13)",
    },
    red: {
      0: "rgb(255, 245, 246)",
      50: "rgb(255, 232, 235)",
      100: "rgb(255, 205, 214)",
      200: "rgb(255, 181, 189)",
      300: "rgb(255, 138, 150)",
      400: "rgb(248, 79, 110)",
      500: "rgb(219, 34, 81)",
      600: "rgb(182, 7, 60)",
      700: "rgb(140, 6, 43)",
      800: "rgb(107, 0, 28)",
      900: "rgb(78, 11, 22)",
      950: "rgb(60, 4, 13)",
    },
    yellow: {
      0: "rgb(255, 248, 229)",
      50: "rgb(255, 241, 204)",
      100: "rgb(255, 228, 153)",
      200: "rgb(255, 214, 102)",
      300: "rgb(255, 208, 80)",
      400: "rgb(255, 201, 51)",
      500: "rgb(255, 187, 0)",
      600: "rgb(204, 150, 0)",
      700: "rgb(153, 112, 0)",
      800: "rgb(102, 75, 0)",
      900: "rgb(51, 37, 0)",
      950: "rgb(36, 26, 0)",
    },
    black: {
      0: "rgba(7, 8, 12, 0.05)",
      50: "rgba(7, 8, 12, 0.1)",
      100: "rgba(7, 8, 12, 0.15)",
      200: "rgba(7, 8, 12, 0.2)",
      300: "rgba(7, 8, 12, 0.3)",
      400: "rgba(7, 8, 12, 0.4)",
      500: "rgba(7, 8, 12, 0.5)",
      600: "rgba(7, 8, 12, 0.6)",
      700: "rgba(7, 8, 12, 0.7)",
      800: "rgba(7, 8, 12, 0.8)",
      900: "rgba(7, 8, 12, 0.9)",
      950: "rgb(7, 8, 12)",
    },
    white: {
      0: "rgba(255, 255, 255, 0.05)",
      50: "rgba(255, 255, 255, 0.1)",
      100: "rgba(255, 255, 255, 0.15)",
      200: "rgba(255, 255, 255, 0.2)",
      300: "rgba(255, 255, 255, 0.3)",
      400: "rgba(255, 255, 255, 0.4)",
      500: "rgba(255, 255, 255, 0.5)",
      600: "rgba(255, 255, 255, 0.6)",
      700: "rgba(255, 255, 255, 0.7)",
      800: "rgba(255, 255, 255, 0.8)",
      900: "rgba(255, 255, 255, 0.9)",
      950: "rgb(255, 255, 255)",
    },
    brand: {
      blue: {
        light: "rgb(112, 132, 255)",
        base: "rgb(64, 91, 255)",
        dark: "rgb(42, 59, 166)",
      },
      cyan: {
        light: "rgb(109, 224, 247)",
        base: "rgb(61, 214, 245)",
        dark: "rgb(35, 140, 163)",
      },
      purple: {
        light: "rgb(182, 117, 228)",
        base: "rgb(163, 79, 222)",
        dark: "rgb(106, 51, 144)",
      },
      pink: {
        light: "rgb(238, 93, 172)",
        base: "rgb(255, 53, 162)",
        dark: "rgb(197, 26, 119)",
      },
      orange: {
        light: "rgb(255, 182, 96)",
        base: "rgb(255, 157, 41)",
        dark: "rgb(213, 123, 16)",
      },
      lime: {
        light: "rgb(237, 255, 158)",
        base: "rgb(221, 255, 70)",
        dark: "rgb(92, 143, 0)",
      },
      yellow: {
        light: "rgb(237, 255, 158)",
        base: "rgb(221, 255, 70)",
        dark: "rgb(92, 143, 0)",
      },
      green: {
        light: "rgb(237, 255, 158)",
        base: "rgb(221, 255, 70)",
        dark: "rgb(92, 143, 0)",
      },
    },
  },
  duration: {
    0: "0ms",
    100: "100ms",
    150: "150ms",
    200: "200ms",
    250: "250ms",
    300: "300ms",
    350: "350ms",
    400: "400ms",
    500: "500ms",
  },
  fontFamily: {
    base: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
    monospace:
      "SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace",
    display: "Audimat\\ 3000 Regulier",
    sora: "Sora, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
  },
  fontSize: {
    100: "0.6875rem",
    200: "0.8125rem",
    300: "0.9375rem",
    400: "1.25rem",
    500: "1.5rem",
    600: "2rem",
    700: "2.75rem",
    800: "3.75rem",
    editorial: {
      40: "2.5rem",
      56: "3.5rem",
      64: "4rem",
      80: "5rem",
    },
  },
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    editorial: {
      semibold: 600,
      bold: 700,
    },
  },
  lineHeight: {
    100: "1rem",
    200: "1.25rem",
    300: "1.5rem",
    400: "1.75rem",
    500: "4.5rem",
    editorial: {
      tight: 1,
      snug: 1.05,
    },
  },
  letterSpacing: {
    editorial: {
      "tight-2px": "-0.125rem",
      "tight-1px": "-0.0625rem",
    },
  },
  gradient: {
    "lime-cyan":
      "linear-gradient(127deg, rgb(221, 255, 70) -38.66%, rgb(61, 214, 245) 83.73%)",
    "lime-pink":
      "linear-gradient(148deg, rgb(221, 255, 70) 13.5%, rgb(255, 53, 162) 90.96%)",
    "lime-blue-pale":
      "linear-gradient(0deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%), linear-gradient(151deg, rgb(237, 255, 158) 5.75%, rgb(112, 132, 255) 90%)",
    "yellow-cyan":
      "linear-gradient(127deg, rgb(221, 255, 70) -38.66%, rgb(61, 214, 245) 83.73%)",
    "yellow-pink":
      "linear-gradient(148deg, rgb(221, 255, 70) 13.5%, rgb(255, 53, 162) 90.96%)",
    "yellow-blue-pale":
      "linear-gradient(0deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.1) 100%), linear-gradient(151deg, rgb(237, 255, 158) 5.75%, rgb(112, 132, 255) 90%)",
    "cyan-blue":
      "linear-gradient(136deg, rgb(61, 214, 245) 22.68%, rgb(64, 91, 255) 127.6%)",
    "cyan-purple":
      "linear-gradient(323deg, rgb(163, 79, 222) -11.93%, rgb(61, 214, 245) 125.4%)",
    "purple-blue":
      "linear-gradient(131deg, rgb(163, 79, 222) -15.82%, rgb(64, 91, 255) 118.85%)",
    "purple-pink":
      "linear-gradient(326deg, rgb(163, 79, 222) -9.86%, rgb(255, 53, 162) 112.59%)",
    "blue-bg-primary":
      "linear-gradient(40deg, rgb(112, 132, 255) -30.41%, rgb(255, 255, 255) 51.41%)",
  },
  size: {
    0: 0,
    1: "0.0625rem",
    2: "0.125rem",
    3: "0.1875rem",
    4: "0.25rem",
    6: "0.375rem",
    8: "0.5rem",
    10: "0.625rem",
    11: "0.6875rem",
    12: "0.75rem",
    13: "0.8125rem",
    14: "0.875rem",
    15: "0.9375rem",
    16: "1rem",
    18: "1.125rem",
    20: "1.25rem",
    24: "1.5rem",
    28: "1.75rem",
    30: "1.875rem",
    32: "2rem",
    36: "2.25rem",
    40: "2.5rem",
    44: "2.75rem",
    48: "3rem",
    50: "3.125rem",
    56: "3.5rem",
    64: "4rem",
    72: "4.5rem",
    80: "5rem",
    96: "6rem",
    112: "7rem",
    128: "8rem",
    144: "9rem",
    160: "10rem",
    176: "11rem",
    192: "12rem",
    208: "13rem",
    224: "14rem",
    240: "15rem",
    256: "16rem",
    320: "20rem",
    400: "25rem",
    480: "30rem",
    560: "35rem",
    640: "40rem",
    720: "45rem",
    800: "50rem",
    960: "60rem",
    1120: "70rem",
    1200: "75rem",
    1280: "80rem",
    1440: "90rem",
  },
  spacing: {
    100: 0,
    200: "0.25rem",
    300: "0.5rem",
    400: "0.75rem",
    500: "1rem",
    600: "1.25rem",
    700: "1.5rem",
    800: "1.75rem",
    900: "2rem",
  },
  text: {
    heading: {
      1: {
        medium: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 500,
          fontSize: "1.25rem",
          lineHeight: "1.75rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "1.25rem",
          lineHeight: "1.75rem",
        },
        extrabold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 800,
          fontSize: "1.25rem",
          lineHeight: "1.75rem",
        },
      },
      2: {
        medium: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 500,
          fontSize: "0.9375rem",
          lineHeight: "1.5rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.9375rem",
          lineHeight: "1.5rem",
        },
        extrabold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 800,
          fontSize: "0.9375rem",
          lineHeight: "1.5rem",
        },
      },
      3: {
        medium: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 500,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
        extrabold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 800,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
      },
    },
    body: {
      1: {
        regular: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          fontSize: "0.9375rem",
          lineHeight: "1.5rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.9375rem",
          lineHeight: "1.5rem",
        },
        extrabold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 800,
          fontSize: "0.9375rem",
          lineHeight: "1.5rem",
        },
      },
      2: {
        regular: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
        extrabold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 800,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
      },
    },
    small: {
      1: {
        regular: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
        medium: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 500,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
      },
    },
    label: {
      1: {
        regular: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
        medium: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 500,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
      },
      2: {
        regular: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 400,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
        medium: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 500,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
        semibold: {
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
          fontWeight: 600,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
      },
    },
    code: {
      1: {
        regular: {
          fontFamily:
            "SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace",
          fontWeight: 400,
          fontSize: "0.8125rem",
          lineHeight: "1.25rem",
        },
      },
      2: {
        regular: {
          fontFamily:
            "SFMono-Regular, Consolas, Liberation Mono, Menlo, Courier, monospace",
          fontWeight: 400,
          fontSize: "0.6875rem",
          lineHeight: "1rem",
        },
      },
    },
    display: {
      1: {
        fontFamily:
          "Sora, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
        fontWeight: 700,
        fontSize: "5rem",
        lineHeight: 1,
        letterSpacing: "-0.125rem",
      },
    },
    editorial: {
      display: {
        fontFamily:
          "Sora, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
        fontWeight: 700,
        fontSize: "5rem",
        lineHeight: 1,
        letterSpacing: "-0.125rem",
      },
      h1: {
        fontFamily:
          "Sora, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
        fontWeight: 700,
        fontSize: "4rem",
        lineHeight: 1,
        letterSpacing: "-0.125rem",
      },
      h2: {
        fontFamily:
          "Sora, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
        fontWeight: 600,
        fontSize: "3.5rem",
        lineHeight: 1,
        letterSpacing: "-0.125rem",
      },
      h3: {
        fontFamily:
          "Sora, Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, Helvetica, Arial, sans-serif",
        fontWeight: 600,
        fontSize: "2.5rem",
        lineHeight: 1.05,
        letterSpacing: "-0.125rem",
      },
    },
  },
  viewport: {
    mobile: 0,
    tablet: "46.25rem",
    desktop: "62rem",
    wide: "75rem",
  },
  zIndex: {
    100: 100,
    200: 200,
    300: 300,
    400: 400,
    500: 500,
    600: 600,
    700: 700,
    800: 800,
    900: 900,
  },
};
